var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-spin',{attrs:{"tip":'',"size":"large","spinning":false}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }